<script setup>
import { computed, ref } from 'vue';
const expanded = ref('');
const props = defineProps({ reactions: { type: Object, default: () => ({}) } });
const groups = computed(() => {
  const grouped = new Map();
  Object.values(props.reactions || {}).forEach(reaction => {
    if (!reaction || typeof reaction.emoji !== 'string' || !reaction.emoji) return;
    const item = grouped.get(reaction.emoji) || { emoji: reaction.emoji, names: [] };
    item.names.push(String(reaction.name || '').trim() || 'Participante sem nome');
    grouped.set(reaction.emoji, item);
  });
  return [...grouped.values()];
});
</script>

<template>
  <div v-if="groups.length" class="devlive-reactions" role="list" aria-label="Reações">
    <span
      v-for="group in groups"
      :key="group.emoji"
      role="listitem"
      class="devlive-reaction"
      :title="group.names.join(', ')"
      :aria-label="`${group.emoji}: ${group.names.join(', ')}`"
    >
      <button type="button" class="devlive-reaction-trigger" :aria-label="`${group.emoji}: ${group.names.join(', ')}`"
        :aria-expanded="expanded === group.emoji" @click="expanded = expanded === group.emoji ? '' : group.emoji"
        @keydown.esc="expanded = ''">
        <span>{{ group.emoji }}</span>
        <span v-if="group.names.length > 1" class="text-xs">{{ group.names.length }}</span>
      </button>
      <span class="devlive-reaction-names" :class="{ 'is-expanded': expanded === group.emoji }" role="tooltip">
        <span v-for="(name, index) in group.names" :key="index">{{ name }}</span>
      </span>
    </span>
  </div>
</template>

<style scoped>
.devlive-reactions { display: flex; flex-wrap: wrap; gap: 4px; margin-top: -3px; padding: 0 6px 2px; position: relative; align-self: flex-start; max-width: 100%; }
.devlive-reaction { position: relative; display: inline-flex; border-radius: 14px; border: 1px solid; @apply border-n-weak bg-n-solid-2; font-size: 16px; line-height: 22px; }
.devlive-reaction-trigger { display: inline-flex; align-items: center; gap: 4px; padding: 4px 8px; min-height: 32px; border-radius: inherit; }
.devlive-reaction-trigger:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
.devlive-reaction-names { display: none; position: absolute; bottom: 100%; inset-inline-start: 0; z-index: 30; width: max-content; max-width: min(240px, 70vw); max-height: 180px; overflow: auto; overflow-wrap: anywhere; padding: 8px 12px; border: 1px solid; border-radius: 8px; font-size: 13px; line-height: 20px; @apply border-n-weak bg-n-solid-2 text-n-slate-12 shadow-md; }
.devlive-reaction-names > span { display: block; }
.devlive-reaction:hover .devlive-reaction-names, .devlive-reaction:focus-within .devlive-reaction-names, .devlive-reaction-names.is-expanded { display: block; }
</style>
